import { Controller } from '@hotwired/stimulus'

// Swaps Turbo's bare "Content missing" for a friendly message with a retry
// when a frame's request fails or returns an error page.
export default class extends Controller {
  static targets = ['template']

  show(event) {
    const frame = event.target.closest('turbo-frame')
    if (!frame) return

    event.preventDefault()
    frame.replaceChildren(this.templateTarget.content.cloneNode(true))
  }

  retry(event) {
    event.target.closest('turbo-frame')?.reload()
  }
}
